import { nowUtcIso } from '@/lib/dates'
import { newUuid } from '@/offline/queue'
import type { Contact } from '@/offline/types'

export interface ContactInput {
  workspace_id: string
  name: string
  phone?: string | null
  kind?: 'customer' | 'seller' | 'both'
  notes?: string | null
}

export interface BuiltContact {
  contact: Contact
  payload: Record<string, unknown>
}

export function buildContact(input: ContactInput): BuiltContact {
  const now = nowUtcIso()
  const contact: Contact = {
    workspace_id: input.workspace_id,
    id: newUuid(),
    kind: input.kind ?? 'both',
    name: input.name.trim(),
    phone: input.phone?.trim() ? input.phone.trim() : null,
    notes: input.notes ?? null,
    revision: 1,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  }
  const payload: Record<string, unknown> = {
    kind: contact.kind,
    name: contact.name,
    phone: contact.phone,
    notes: contact.notes,
  }
  return { contact, payload }
}
